import * as API from '@/services/API';

export default {
  list({ commit }, filters) {
    commit('SET_LOADING', true, { root: true });
    return API.apiClient
      .get('/leads', { params: filters })
      .then((response) => {
        commit('SET_LIST', response.data);
        commit('SET_LOADING', false, { root: true });
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
        commit('SET_LOADING', false, { root: true });
        return null;
      });
  },

  view({ commit }, leadId) {
    return API.apiClient
      .get('/leads/' + leadId)
      .then((response) => {
        commit('SET_CURRENT_LEAD', response.data);
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  update({ commit, dispatch }, payload) {
    return API.apiClient
      .put('/leads/' + payload.id, payload)
      .then((response) => {
        dispatch('list');
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  sendEmailMessage({ commit, dispatch }, payload) {
    payload.threadable_type = 'App\\Models\\Lead';
    return API.apiClient
      .post('/email-messages', payload)
      .then((response) => {
        dispatch('view', payload.threadable_id);
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
};
